import { Copy } from "lucide-react";
import { toast } from "sonner";
import { SIGN_OFF, copy } from "@/components/bulk/common";

const CopyBox = ({ label, text, testid }) => (
  <div className="copy-box" data-testid={testid}><small>{label}</small><code>{text}</code><button type="button" className="icon-btn" onClick={() => copy(text, toast)} title="Kopyala" data-testid={`${testid}-copy`}><Copy size={14} /></button></div>
);

export function TemplateGuide() {
  const media = `${window.location.origin}/api/public/campaign/{{3}}`;
  return (
    <section className="panel template-guide" data-testid="template-guide">
      <h3>Toplu mesaj şablonu nasıl oluşturulur?</h3>
      <p className="form-hint">WhatsApp, işletmelerin toplu mesajları Meta onaylı şablonla göndermesini zorunlu tutar. Bu şablonu bir kez oluşturmanız yeterli; her kampanyada metni ve görseli uygulamadan değiştirirsiniz.</p>
      <ol className="guide-steps">
        <li>Twilio Console → <b>Messaging → Content Template Builder</b> → <b>Create new</b>.</li>
        <li>Ad: <code>emlak_toplu_mesaj</code>, Dil: <b>Turkish</b>, İçerik türü: <b>Card</b>.</li>
        <li>Aşağıdaki metinleri ilgili alanlara kopyalayın:
          <CopyBox label="Title (mesaj metni)" text={`Merhaba {{1}}, {{2}} ${SIGN_OFF}`} testid="guide-body" />
          <CopyBox label="Media URL" text={media} testid="guide-media" />
          <CopyBox label="Button → Quick reply → Text" text="Mesaj istemiyorum" testid="guide-button" />
          <CopyBox label="Button → Quick reply → ID" text="optout" testid="guide-button-id" />
        </li>
        <li>Örnek değerler (Meta onayı için): <b>{"{{1}}"}</b> Ahmet Yılmaz · <b>{"{{2}}"}</b> Cumhuriyetimizin 103. yılı kutlu olsun! · <b>{"{{3}}"}</b> ornek.jpg</li>
        <li><b>Save and submit for WhatsApp approval</b> → Kategori: <b>Marketing</b>. Onay genellikle birkaç dakika ile 24 saat sürer.</li>
        <li>Onaylanınca şablonun <b>HX…</b> kodunu kopyalayın: Ayarlar → WhatsApp mesajı → Twilio bilgileri → <b>Toplu mesaj şablon kodu</b> alanına yapıştırıp kaydedin.</li>
      </ol>
      <div className="guide-notes">
        <b>Bilmeniz gerekenler</b>
        <ul>
          <li>Meta yeni hesaplara günde <b>250</b> farklı kişiye mesaj izni verir; kullanım arttıkça sınır 2.000 → 10.000 → 100.000'e çıkar. Güncel sınırınızı Meta WhatsApp Yöneticisi'nde görüp Toplu Mesaj sayfasındaki "Günlük gönderim sınırı" kartına girin. Sınır dolunca uygulama kalan kişilere ertesi gün kendiliğinden devam eder.</li>
          <li>Türkiye'de pazarlama mesajının tanesi yaklaşık <b>0,016 $</b> (Meta + Twilio). 3.800 kişi için kampanya başına yaklaşık 60 $ tutar.</li>
          <li>"Mesaj istemiyorum" butonuna basan kişi listeden otomatik çıkarılır ve bir daha kampanya mesajı almaz. Çok kişi engellerse hattın kalitesi düşer; mesajlarınızı sizi tanıyan kişilere gönderin.</li>
          <li>Kampanyaya cevap yazan kişiler Mesajlar sayfasında görünür ve 24 saat içinde onlara cevap verebilirsiniz.</li>
        </ul>
      </div>
    </section>
  );
}
